import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function ProblemIdentification() {
  const items = ['Cada mañana necesitas varios minutos antes de poder moverte con normalidad', 'Subes las escaleras con cuidado porque las rodillas crujen o duelen', 'Has probado suplementos de glucosamina, colágeno y condroitina sin resultados duraderos', 'Tu médico te dice "es normal para tu edad" pero algo dentro de ti sabe que no debería ser así', 'El frío y la humedad empeoran el dolor de forma predecible', 'Sientes que tu cuerpo ya no te responde como antes', 'Has dependido del ibuprofeno o el acetaminofén más de lo que te gustaría admitir'];
  return <section className="bg-cream py-20 px-6 md:px-12 lg:px-24" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        <FadeIn data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-text-black mb-12" data-id="element-162">
            ¿Te identificas con alguna de estas situaciones?
          </h2>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-163">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-164">
              <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-gold-light" data-id="element-165">
                <CheckCircle2 className="text-sage flex-shrink-0 mt-1" size={28} data-id="element-166" />
                <p className="text-lg md:text-xl text-text-black" data-id="element-167">{item}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} data-id="element-168">
          <div className="bg-dark-green text-white p-8 rounded-xl text-center shadow-md" data-id="element-169">
            <p className="text-xl md:text-2xl font-serif font-medium" data-id="element-170">
              Si marcaste 3 o más: no estás envejeciendo mal. Tienes un fuego
              interior activo que nadie te ha explicado cómo apagar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}